import { InjectionToken, Signal } from '@angular/core';
import { UserRole } from '@dss-libs/shared/type/common-types';

export const CURRENT_USER_ROLE = new InjectionToken<Signal<UserRole | undefined>>('CURRENT_USER_ROLE');
